module.exports = __webpack_public_path__ + "img/ios.e1d6dfe7.svg";